import useUser from "../../../api/api-hooks/auth/useUser";
import FeedbackMediaPreview from "../../../views/supportal/FeedbackView/FeedbackMediaPreview";
import { UppyFileInterface } from "../../Inputs/UppyFile";
import { FeedbackMessage } from "../BrieChatFeedback";
import { SearchGPTMessage } from "../GPTConvoTypes";
import BrieResponseMessage from "./BrieResponseMessage";

interface MessageProps {
  message: SearchGPTMessage | FeedbackMessage | undefined;
  attachments?: UppyFileInterface[];
  loading?: boolean;
}

const BrieChatMessage = ({ message, loading, attachments }: MessageProps) => {
  const { user } = useUser();
  if (loading) {
    return (
      <div
        className="brie-message px-1 py-3"
        style={{ backgroundColor: "var(--superlight)" }}
      >
        <div
          className="dot-flashing"
          style={{ marginLeft: 29, marginTop: 0 }}
        ></div>
      </div>
    );
  }

  if (!message) return null;

  const feedbackMessage: string = "Message" in message ? message?.Message : "";
  const sender =
    typeof message.Sender === "object" ? message?.Sender?.id : message.Sender;
  let color = sender === "Brie" || sender !== user.id ? "gray" : "green";
  let position = sender === "Brie" || sender !== user.id ? "left" : "right";

  if (loading && !feedbackMessage) {
    color = "gray";
    position = "left";
  }

  return (
    <div
      className="brie-message border border-superlight btn-oauth"
      style={{
        backgroundColor: color === "gray" ? "var(--ultralight)" : "#c8f3d8",
        marginLeft: position === "right" ? "auto" : undefined,
      }}
    >
      {feedbackMessage && (
        <div className="p-2">
          {feedbackMessage}
          <div>
            {attachments && attachments.length > 0 && (
              <>
                {attachments.map((file) => (
                  <FeedbackMediaPreview key={file.id} readonly file={file} />
                ))}
              </>
            )}
          </div>
        </div>
      )}

      {!feedbackMessage && !loading && (
        <>
          {sender === "Brie" ? (
            <BrieResponseMessage message={message as SearchGPTMessage} />
          ) : (
            <div className="p-2">
              {("Message" in message && message?.Message) || ""}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default BrieChatMessage;
